import { formatCount } from '@/utils/number';
import type { PcmpRequestActResult, PcmpRequestDecision } from '../types/pcmpRequested.types';

interface DecisionCopy {
  label: string;
  title: string;
  submit: string;
  pending: string;
  note: string;
  placeholder: string;
}

export const PCMP_REQUEST_DECISION_COPY = {
  PROCESS: {
    label: 'Process',
    title: 'Mark Processing',
    submit: 'Mark Processing',
    pending: 'Saving...',
    note: 'Tells the requester it is being looked at. The request stays open until it is approved or rejected.',
    placeholder: 'Anything the requester should know',
  },
  APPROVE: {
    label: 'Approve',
    title: 'Approve Request',
    submit: 'Approve',
    pending: 'Approving...',
    note: "Approving runs the category's action on each proposal. A proposal the action refuses is left out, its request stays open and the reason is listed.",
    placeholder: 'Optional note for the timeline',
  },
  REJECT: {
    label: 'Reject',
    title: 'Reject Request',
    submit: 'Reject',
    pending: 'Rejecting...',
    note: 'The request is closed without running its action. The requester sees your reason.',
    placeholder: 'Why the request is rejected',
  },
} as const satisfies Record<PcmpRequestDecision, DecisionCopy>;

const DECISION_PAST = {
  PROCESS: 'marked Processing',
  APPROVE: 'approved',
  REJECT: 'rejected',
} as const satisfies Record<PcmpRequestDecision, string>;

/** One line for the toast: what was done, and what approving set in motion. */
export function describePcmpActOutcome(result: PcmpRequestActResult): string {
  const parts = [`${formatCount(result.done.length, 'request')} ${DECISION_PAST[result.decision]}`];
  for (const batch of result.urgentBatches) {
    parts.push(`urgent batch #${batch.batchNo} published`);
  }
  if (result.preBatched > 0) {
    parts.push(`${formatCount(result.preBatched, 'proposal')} moved to Pre-Batch`);
  }
  return parts.join(' · ');
}

export const PCMP_REQUESTED_EMPTY_MESSAGE = {
  default: 'No requests on this tab',
  APPROVED: 'No approved requests yet',
  PRE_BATCH: 'No proposals are waiting in Urgent Pre-Batch',
  BATCHES: 'No urgent batches found',
} as const;
